import { useRef, useState, useCallback } from "react";

// Tiny helper to guard async actions per-key (e.g. `${action}:${id}`).
// Prevents double-clicks and lets multiple different actions run in parallel,
// while exposing isBusy(key) for spinner/disabled state.
export function useBusyKeys() {
  const ref = useRef(new Set());
  const [, force] = useState(0);
  const rerender = useCallback(() => force((x) => x + 1), []);

  const isBusy = useCallback((key) => ref.current.has(key), []);

  const run = useCallback(async (key, fn) => {
    if (ref.current.has(key)) return;
    ref.current.add(key);
    rerender();
    try {
      return await fn();
    } finally {
      ref.current.delete(key);
      rerender();
    }
  }, [rerender]);

  return { isBusy, run };
}
